if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counter = this.querySelector('.product-media-modal__counter');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(-1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(1);
          });
        }

        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowLeft') this.navigate(-1);
          if (event.code === 'ArrowRight') this.navigate(1);
        });

        const content = this.querySelector('.product-media-modal__content');
        if (content) this.setupSwipe(content);
      }

      getMediaItems() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return [];

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;

        return [...content.children].filter((element) => {
          if (!isDesktop) return true;

          if (element.matches('.product__media-item--variant')) {
            return element === content.querySelector(':scope > .product__media-item--variant');
          }

          return true;
        });
      }

      resolveMediaElement(element) {
        if (!element) return null;
        const content = this.querySelector('.product-media-modal__content');
        if (element.parentElement === content) return element;
        return element.closest('.product-media-modal__content > *');
      }

      getActiveIndex() {
        return this.getMediaItems().findIndex((element) => element.classList.contains('active'));
      }

      navigate(direction) {
        const items = this.getMediaItems();
        if (items.length <= 1) return;

        window.pauseAllMedia?.();

        let index = this.getActiveIndex();
        if (index === -1) index = 0;

        index = (index + direction + items.length) % items.length;
        this.setActiveMedia(items[index]);
      }

      setActiveMedia(activeMedia) {
        const mediaElement = this.resolveMediaElement(activeMedia);
        if (!mediaElement) return;

        this.querySelectorAll('.product-media-modal__content > *').forEach((element) => {
          element.classList.remove('active');
        });
        mediaElement.classList.add('active');

        mediaElement.scrollIntoView({ block: 'center', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        const activeMediaNode = mediaElement.matches('[data-media-id]')
          ? mediaElement
          : mediaElement.querySelector('[data-media-id]');

        if (container && activeMediaNode?.width) {
          container.scrollLeft = (activeMediaNode.width - container.clientWidth) / 2;
        }

        const activeMediaTemplate = activeMediaNode?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMediaNode?.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMediaNode.loadContent();
        }

        this.updateNav();
      }

      updateNav() {
        const items = this.getMediaItems();
        const index = this.getActiveIndex();
        const showNav = window.matchMedia('(max-width: 749px)').matches && items.length > 1;

        if (this.prevButton) this.prevButton.hidden = !showNav;
        if (this.nextButton) this.nextButton.hidden = !showNav;

        if (this.counter) {
          this.counter.hidden = !showNav;
          this.counter.textContent = showNav ? `${index + 1} / ${items.length}` : '';
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.updateNav();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(
          `.product-media-modal__content [data-media-id="${mediaId}"]`
        );

        if (activeMedia) {
          this.setActiveMedia(activeMedia);
          return;
        }

        const firstItem = this.getMediaItems()[0];
        if (firstItem) this.setActiveMedia(firstItem);
      }

      setupSwipe(content) {
        let startX = 0;
        let startY = 0;

        content.addEventListener(
          'touchstart',
          (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );

        content.addEventListener(
          'touchend',
          (event) => {
            if (!this.hasAttribute('open')) return;
            if (!window.matchMedia('(max-width: 749px)').matches) return;

            const diffX = event.changedTouches[0].clientX - startX;
            const diffY = event.changedTouches[0].clientY - startY;

            if (Math.abs(diffX) < 50 || Math.abs(diffX) < Math.abs(diffY)) return;

            if (diffX < 0) this.navigate(1);
            else this.navigate(-1);
          },
          { passive: true }
        );
      }
    }
  );
}
